export const CONTROL_LISTING_INFO_MODAL_KEY = 'control_listing_creation_info';

export const PUBLISH_STEP_VARIANTS = {
  PUBLISH: 'publish',
  NO_PERMISSION: 'noPermission',
  REVIEW: 'review',
};

export function getPublishStepVariant(permissions, listingSupervision) {
  const isAdmin = permissions?.allPermissions?.includes('is_company_admin');
  const canPublish = permissions?.allPermissions?.includes(
    'can_publish_in_portals'
  );
  const systemActive = listingSupervision?.system_is_active === true;
  const creationSupervision = listingSupervision?.creation_supervision === true;

  if (isAdmin) {
    return PUBLISH_STEP_VARIANTS.PUBLISH;
  }

  if (!systemActive) {
    return canPublish
      ? PUBLISH_STEP_VARIANTS.PUBLISH
      : PUBLISH_STEP_VARIANTS.NO_PERMISSION;
  }

  return creationSupervision
    ? PUBLISH_STEP_VARIANTS.REVIEW
    : PUBLISH_STEP_VARIANTS.PUBLISH;
}

export function isControlListingEnabled(listingSupervision) {
  return listingSupervision?.system_is_active === true;
}

export function shouldShowListingCreationSupervisionBanner(
  listingSupervision,
  { hideControlListingInfoBanner = false } = {}
) {
  if (hideControlListingInfoBanner || !listingSupervision) {
    return false;
  }

  return (
    listingSupervision.system_is_active === true &&
    listingSupervision.creation_supervision === true
  );
}
